import React, { useCallback } from 'react';
import { FormattedMessage } from 'react-intl';

import { Button } from 'ui-components/components/button';
import { Modal } from 'ui-components/components/modal';
import { ModalBody } from 'ui-components/components/modal/modal-body';
import { ModalFooter } from 'ui-components/components/modal/modal-footer';
import { ModalHeader } from 'ui-components/components/modal/modal-header';
import { THEME_CONSTANTS } from 'ui-components/services/button-theme-service';

import messages from './messages';
import style from './style.module.less';
import AsModal from '../../../components/as-modal';

/**
 * @param {object} params
 * @param {() => void} params.onClose
 * @param {(taxIdentifierId: string) => void} params.onDelete
 * @param {string} params.taxIdentifierId
 * @returns {JSX.Element}
 */
const DeleteTaxIdentifierModal = ({ onClose, onDelete, taxIdentifierId }) => {
  const onDeleteClicked = useCallback(() => {
    onDelete(taxIdentifierId);
  }, [onDelete, taxIdentifierId]);

  return (
    <Modal className={style.modal}>
      <ModalHeader closeModal={onClose}>
        <FormattedMessage {...messages.deleteHeader} />
      </ModalHeader>
      <ModalBody className={style['delete-tax-id-body']}>
        <div className={style.warning}>
          <FormattedMessage {...messages.confirmMessage} />
        </div>
      </ModalBody>
      <ModalFooter className={style['modal-footer']}>
        <Button onClick={onClose} theme={THEME_CONSTANTS.tertiary}>
          <FormattedMessage {...messages.cancel} />
        </Button>
        <Button onClick={onDeleteClicked} theme={THEME_CONSTANTS.danger}>
          <FormattedMessage {...messages.delete} />
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default AsModal(DeleteTaxIdentifierModal);
